import { useStoreState } from "../../../store/hooks";
import { Tenant } from "../../auth/models";

export const useTenant = (): Tenant | null => {
    return useStoreState((state) => state.auth.currentTenant);
};
